import React, { FC, useEffect } from 'react';
import { useOutletContext } from 'react-router-dom';
import { RiskFlowControl } from 'types/RiskControl';
import { useAppContext } from 'hooks';
import { stepsObject } from './stepsObject';
import { Step, Risk } from './types';

const PageHandler: FC = () => {
  const outletContext = useOutletContext<RiskFlowControl>();
  const { riskFlow, setRiskFlow } = outletContext;
  const context = useAppContext();
  const { currentStep } = context.state.steps;

  useEffect(() => {
    setRiskFlow({
      ...riskFlow,
      hadSuccess: false,
      hadError: false,
      riskProcessed: false,
    });

    context.dispatch({
      type: 'set_steps_config',
      payload: {
        currentStep: 0,
      },
    });
  }, []);

  useEffect(() => {
    context.dispatch({
      type: 'set_steps_config',
      payload: {
        currentStep: 0,
        stepsQuantity:
          Object.values(stepsObject[riskFlow.data.freightRisk as Risk]).length -
          1,
      },
    });
  }, [riskFlow.data]);

  const CurrentPage: React.FunctionComponent =
    stepsObject[riskFlow.data.freightRisk as Risk][currentStep as Step];

  return <CurrentPage />;
};

export default PageHandler;
